import Vue from 'vue'
import Vuex from 'vuex'
import projects from './modules/projects'
import DriveDirections from '../../src/driveDirection'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    driveDirection: DriveDirections.Left,
    trajectory: null,
    trajectories: [],
    predictions: []
  },
  mutations: {
    setDriveDirection (state, driveDirection) {
      state.driveDirection = driveDirection
    },
    setTrajectory (state, trajectory) {
      state.trajectory = trajectory
    },
    setTrajectories (state, trajectories) {
      state.trajectories = trajectories
    },
    setPredictions (state, predictions) {
      state.predictions = predictions
    }
  },
  getters: {
    getTrajectory: state => state.trajectory,
    getTrajectories: state => state.trajectories,
    getPredictions: state => state.predictions
  },
  actions: {
    setDriveDirection ({commit}, driveDirection) {
      commit('setDriveDirection', driveDirection)
    },
    setTrajectory ({commit}, trajectory) {
      commit('setTrajectory', null)
      commit('setTrajectories', [])
      commit('setDriveDirection', DriveDirections.Left)
      window.setTimeout(() => {
        commit('setTrajectory', trajectory)
      })
    },
    setTrajectories ({commit}, trajectories) {
      commit('setTrajectories', trajectories)
    },
    setPredictions ({commit}, predictions) {
      commit('setPredictions', predictions)
    }
  },
  modules: {
    projects
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js